var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitMainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 200,
    viewBox: "0 0 223 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 8998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M180.079 69.2271C191.409 69.2271 200.595 60.0281 200.595 48.6805C200.595 37.3328 191.409 28.1338 180.079 28.1338C168.748 28.1338 159.562 37.3328 159.562 48.6805C159.562 60.0281 168.748 69.2271 180.079 69.2271Z",
    fill: "#A32DC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M179.825 44.5208C179.582 43.3274 182.021 41.3544 182.837 40.9244C185.812 39.3644 190.382 40.5408 192.013 43.5208C195.748 50.3541 185.247 60.0974 179.828 62.5008C179.202 62.0008 164.368 50.8874 167.846 43.7741C171.324 36.6608 178.966 40.2774 179.825 44.5208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M125.868 93.9772V25.0005C125.866 23.0025 125.072 21.0869 123.661 19.6742C122.25 18.2612 120.338 17.4665 118.343 17.4639H22.1533C20.1611 17.4709 18.2528 18.2675 16.8457 19.6799C15.4386 21.0922 14.6472 23.0052 14.6445 25.0005V161.764C14.6472 163.76 15.4413 165.674 16.8524 167.085C18.2635 168.496 20.1761 169.288 22.1699 169.287H118.359C119.292 169.293 120.218 169.116 121.082 168.764",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.2169 22.5793H116.296C119.442 22.5793 121.993 25.1338 121.993 28.286V158.486C121.993 161.639 119.442 164.193 116.296 164.193H24.2169C21.0711 164.193 18.5195 161.639 18.5195 158.486V28.286C18.5195 25.1338 21.0711 22.5793 24.2169 22.5793Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M114.386 33.1172H27.2696C25.5582 33.1172 24.1709 34.5065 24.1709 36.2205V56.7138C24.1709 58.4275 25.5582 59.8172 27.2696 59.8172H114.386C116.097 59.8172 117.485 58.4275 117.485 56.7138V36.2205C117.485 34.5065 116.097 33.1172 114.386 33.1172Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70.2543 44.3646C71.778 44.3646 73.0135 43.1272 73.0135 41.6012C73.0135 40.0749 71.778 38.8379 70.2543 38.8379C68.7306 38.8379 67.4951 40.0749 67.4951 41.6012C67.4951 43.1272 68.7306 44.3646 70.2543 44.3646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M62.5524 54.0977C62.5311 53.071 62.7145 52.0507 63.0923 51.0957C63.4697 50.141 64.0339 49.2714 64.7512 48.538C65.4688 47.8044 66.3251 47.2214 67.2704 46.8237C68.2156 46.4257 69.2305 46.2207 70.2559 46.2207C71.2814 46.2207 72.2962 46.4257 73.2415 46.8237C74.1867 47.2214 75.0431 47.8044 75.7607 48.538C76.478 49.2714 77.0421 50.141 77.4196 51.0957C77.7973 52.0507 77.9807 53.071 77.9594 54.0977H62.5524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.5029 71.7363H106.058",
    stroke: "white",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.5029 78.8906H106.058",
    stroke: "white",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.5029 124.951H106.058",
    stroke: "#EAEAEA",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.3545 131.714H89.2064",
    stroke: "#EAEAEA",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M57.6693 99.7574L51.8813 105.924L44.2793 98.764L50.0706 92.6007C51.0206 91.5947 52.3296 91.0061 53.7119 90.9634C55.0938 90.9211 56.4365 91.4281 57.4463 92.3741C58.4471 93.3271 59.0319 94.6374 59.0735 96.0197C59.1155 97.4024 58.6109 98.7454 57.6693 99.7574Z",
    fill: "#EEC11B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M80.166 95.7432C79.9197 94.5499 82.3627 92.5765 83.1615 92.1465C86.1337 90.5865 90.7069 91.7632 92.3345 94.7432C96.0722 101.577 85.5712 111.317 80.1493 113.723C79.5269 113.223 64.6925 102.11 68.1673 94.9965C71.6421 87.8832 79.3039 91.4965 80.166 95.7432Z",
    fill: "#A32DC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M68.9727 107.924H77.0572",
    stroke: "#EEC11B",
    strokeWidth: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M73.0137 111.971V103.874",
    stroke: "#EEC11B",
    strokeWidth: 5.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M151.254 87C142.243 87.0003 133.391 89.3761 125.587 93.8886C117.783 98.401 111.303 104.891 106.797 112.707C102.29 120.521 99.917 129.387 99.917 138.412C99.917 147.436 102.29 156.302 106.797 164.117C111.303 171.932 117.783 178.422 125.587 182.935C133.391 187.447 142.243 189.823 151.254 189.823C160.265 189.823 169.117 187.447 176.921 182.935C184.725 178.422 191.205 171.932 195.711 164.117C200.216 156.301 202.588 147.436 202.588 138.412C202.588 129.387 200.216 120.522 195.711 112.707C191.205 104.891 184.725 98.401 176.921 93.8886C169.117 89.3761 160.265 87.0003 151.254 87Z",
    fill: "#A32DC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M163.166 125.384L161.795 124.418L175.711 104.421L177.082 105.388L163.166 125.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M138.237 155.938L134.198 161.72L137.845 164.274L141.883 158.492L138.237 155.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M165.523 130.617L146.518 157.827C145.52 159.277 143.825 159.854 142.76 159.111L137.362 155.334C136.3 154.591 136.267 152.814 137.279 151.361L156.284 124.151C157.282 122.701 158.976 122.121 160.041 122.867L165.44 126.647C166.502 127.387 166.535 129.164 165.523 130.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M142.268 170.567C141.899 171.114 141.37 171.532 140.754 171.764C140.503 171.87 140.23 171.912 139.959 171.888C139.688 171.863 139.427 171.773 139.199 171.624L126.885 162.987C126.019 162.381 125.999 160.914 126.821 159.737C127.191 159.187 127.723 158.767 128.342 158.534C128.594 158.434 128.865 158.395 129.134 158.421C129.403 158.447 129.663 158.537 129.89 158.684L142.205 167.321C143.054 167.924 143.08 169.384 142.268 170.567Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitMainIcon);
export default __webpack_public_path__ + "static/media/benefit_main_icon.b6da40de.svg";
export { ForwardRef as ReactComponent };